import React, { useMemo } from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import { Nullable } from '@tager/web-core';

import { colors } from '@/constants/theme';
import { ProductType } from '@/typings/model';
import ContentContainer from '@/components/ContentContainer';
import CatalogCardView from '@/components/Cards/CatalogCard/CatalogCardView';

type Props = {
  data: Nullable<ProductType>;
};

function CatalogCard({ data }: Props) {
  const t = useTranslations();

  const paramsFiltered = useMemo(() => {
    const brandList: Record<string, string>[] = [];
    const sizeList: Record<string, string>[] = [];

    if (!data) {
      return [];
    }

    if (data?.brand) {
      brandList.push({
        name: t('manufacturer'),
        value: data.brand,
      });
    }
    if (data?.fields) {
      data.fields.forEach((field) => {
        if (field.name === 'MEHANIZM-TRANSFORMACII') {
          brandList.push({
            name: field.label,
            value: field.value,
          });
        } else {
          sizeList.push({
            name: field.label,
            value: field.value,
          });
        }
      });
    }

    return [
      { name: 'BRAND', data: brandList },
      { name: 'SIZE', data: sizeList },
    ];
  }, [data]);

  return (
    <Component>
      <ContentContainer>
        <CatalogCardView data={data} params={paramsFiltered ?? []} />
      </ContentContainer>
    </Component>
  );
}

export default CatalogCard;

const Component = styled.div`
  border: 1px solid ${colors.gray100};
  padding: 2px 0;
`;
